// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取用户订阅推送关系 GET /stock-case/get-notice-sub */
export async function stockCaseGetNoticeSubUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseGetNoticeSubUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStockChannelNoticeSubResp>('/stock-case/get-notice-sub', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股池案例列表 GET /stock-case/list */
export async function stockCaseListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseListResp>('/stock-case/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 案例股池案例收益列表 GET /stock-case/profit/list */
export async function stockCaseProfitListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseProfitListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockCaseProfitListResp>('/stock-case/profit/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 订阅/取消案例推送 POST /stock-case/sub-notice */
export async function stockCaseSubNoticeUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockCaseSubNoticeUsingPOSTParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/stock-case/sub-notice', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
